import { render, staticRenderFns } from "./RestrictionsSettings.vue?vue&type=template&id=ae69828e&scoped=true&"
import script from "./RestrictionsSettings.vue?vue&type=script&lang=js&"
export * from "./RestrictionsSettings.vue?vue&type=script&lang=js&"
import style0 from "./RestrictionsSettings.vue?vue&type=style&index=0&id=ae69828e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae69828e",
  null
  
)

export default component.exports